import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../../api/profile";

import { ReactComponent as UserIcon } from "../../../resources/icons/user.svg";
import { ReactComponent as LogoutIcon } from "../../../resources/icons/logout.svg";
import { ReactComponent as Phone } from "../../../resources/icons/phone.svg";
import { ReactComponent as Email } from "../../../resources/icons/mail.svg";
import PersonalDetails from "../../elements/profile/PersonalDetails";
import LogoutModal from "../../elements/profile/LogoutModal";
import { useAuthContext } from "../../../contexts/authContext";

interface MeData {
  name: string;
  email: string;
  phone: string;
  type: string;
  image: string | null;
  memberSince: string;
}

const AdminProfile: React.FC = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<MeData>({
    name: "",
    email: "",
    phone: "",
    type: "",
    image: null,
    memberSince: "",
  });
  const fetched = useRef(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { logout, loggingOut } = useAuthContext();

  useEffect(() => {
    const fetchUser = async () => {
      if (fetched.current) return;
      try {
        const data = await getMe();
        setUser(data);
        fetched.current = true;
      } catch {}
    };
    fetchUser();
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="flex flex-row">
      <div className="flex-1 ml-[17.5rem]">
        <h1 className="p-6 text-2xl font-bold">My profile</h1>

        <div className="px-6 py-12 bg-[#F9FAFB] flex justify-between items-center">
          <div className="flex items-center gap-4">
            <div>
              {user.image ? (
                <img
                  src={user.image}
                  alt="Profile"
                  className="w-20 h-20 rounded-full object-cover"
                />
              ) : (
                <UserIcon className="w-20 h-20 text-gray-400" />
              )}
            </div>
            <div>
              <h2 className="text-xl font-bold">{user.name}</h2>
              <span className="inline-block mt-1 px-3 py-1 text-xs font-medium text-[#1672EC] bg-[#F0F9FF] border border-[#B9E6FE] rounded-full">
                {user.type.charAt(0).toUpperCase() +
                  user.type.slice(1).toLowerCase()}
              </span>
            </div>
          </div>
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-2 px-4 py-2 border rounded-md hover:bg-gray-100"
          >
            <LogoutIcon className="w-5 h-5 text-gray-600" />
            Logout
          </button>
        </div>

        <div className="px-6 py-8">
          <div>
            <h3 className="text-lg font-bold mb-4">Personal details</h3>
            <div className="max-w-screen flex flex-wrap gap-x-12 gap-y-4">
              <PersonalDetails
                label="Phone number"
                Icon={Phone}
                info={user.phone}
              />
              <PersonalDetails label="Email" Icon={Email} info={user.email} />
            </div>
          </div>
        </div>

        <LogoutModal
          isOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          handleLogout={handleLogout}
          loading={loggingOut}
        />
      </div>
    </div>
  );
};

export default AdminProfile;
